module.exports = __webpack_public_path__ + "media/src/public/img/icons/shevron-5cefe9d6bd0264844f85561f09a6a1bd.svg";